import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';
import "../../css/ListScores.css";


const DisplayScorePercent = ({ assessment, handleClose }) => {
	const { t } = useTranslation();
	
	let key = (assessment && assessment.questionnaire && assessment.questionnaire.length > 0) ? assessment.questionnaire[0].questionnaireId : 0;
	

	return (
		<div key={key}>
			<Modal show={true} onHide={handleClose} size="sm">
	        <Modal.Header>
	          <Modal.Title></Modal.Title>
	        </Modal.Header>
	        <Modal.Body>
		        <div className="row">
					<div className="col-sm-6"><b>{'  ' + t("page.green") + ' '}</b>
					</div>
					<div className="col-sm-6">
						{assessment.scorePercentLow}
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6"><b>{'  ' + t("page.yellow") + ' '}</b>
					</div>
					<div className="col-sm-6">
						{assessment.scorePercentMedium}
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6"><b>{'  ' + t("page.orange") + ' '}</b></div>
					<div className="col-sm-6">
						{assessment.scorePercentHigh}
					</div>
				</div>
	        </Modal.Body>
	        <Modal.Footer>
	          <Button variant="secondary" onClick={handleClose}>
	            {t("page.close")}
	          </Button>
	        </Modal.Footer>
	      </Modal>
			
		</div>
	)
}

export default DisplayScorePercent;